module.exports = {
  'entityName': 'request',
  'pagination': {
    'rowsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  'fields': [
    {
      slim: true,
      'value': 'request_date',
      'text': 'Request date',
      'type': 'datetime',
      readonly: true
    },
    {
      slim: true,
      'value': 'provider_id',
      'text': 'Provider',
      render: item => item.provider.name,
      readonly: true
    },
    {
      slim: true,
      'value': 'response_date',
      'text': 'Response date',
      'type': 'datetime',
      visible: item => item.status !== 'NEW',
      'validators': [
        'required'
      ]
    },
    {
      slim: true,
      "value": "first_request",
      "text": "First request",
      "table": true,
      "type": "check",
      readonly: true,
      visible: item => item.first_request
    },    
    {
      slim: true,
      'value': 'response_pdf',
      'text': 'Pdf',
      'type': 'file',
      'accept': 'application/pdf',
      visible: item => item.status === 'CONFIRMED',
      'validators': [
        'required'
      ]
    }
  ],
  'actions': [
    'upsert'
  ]
}
